// 上报铸剑权限编码使用情况map
const authUseCache = new Map()

// 上报铸剑数据字典编码使用情况map
const lookupUseCache = new Map()

// 按钮权限和按钮内容上报的 map
const buttonAuthTextCache = new Map()

// 权限 code 使用上报 qt(提供后台分析前端使用旧权限编码的情况)
export const authReportQt = function (val) {
  try {
    const menuId = window.__ERPMODULE__.id
    const authKey = val + menuId
    if (!authUseCache.has(authKey)) {
      authUseCache.set(authKey, true)
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_auth_use_data', 'OTHER', {
          authCode: val,
          menuID: menuId
        }]
      })
    }
  } catch (error) {
    console.error('【ERP-auth-report】', error)
  }
}

// 数据字典使用情况上报（提供后台分析前端使用数据字典的情况）
export const lookUpReportQt = function (val) {
  try {
    const menuId = window.__ERPMODULE__.id
    const lookupCodeKey = val + menuId
    if (!lookupUseCache.has(lookupCodeKey)) {
      // console.log('数据字典上报:', val)
      lookupUseCache.set(lookupCodeKey, true)
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_lookup_use_data', 'OTHER', {
          lookupCode: val,
          menuID: menuId
        }]
      })
    }
  } catch (error) {
    console.error('【ERP-lookup-report】', error)
  }
}

// 按钮的权限编码使用位置情况上报
export const buttonAuthTextReportQt = function (auth, text) {
  try {
    const menuId = window.__ERPMODULE__.id
    const buttonAuthTextKey = auth + text + menuId
    if (!buttonAuthTextCache.has(buttonAuthTextKey)) {
      buttonAuthTextCache.set(buttonAuthTextKey, true)
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_button_auth_text_use', 'OTHER', {
          authCode: auth,
          buttonText: text,
          menuID: menuId
        }]
      })
    }
  } catch (error) {
    console.error('【ERP-lookup-report】', error)
  }
}



// WEBPACK FOOTER //
// ./src/public/utils/qt-report.js